/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Swap_Muscle_PromptInputs */

const en_us2_swap_muscle_prompt = /** @type {(inputs: Swap_Muscle_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`For which muscle?`)
};

const pt_br2_swap_muscle_prompt = /** @type {(inputs: Swap_Muscle_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Para qual músculo?`)
};

const es_419_swap_muscle_prompt = /** @type {(inputs: Swap_Muscle_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Para qué músculo?`)
};

const pt_pt2_swap_muscle_prompt = /** @type {(inputs: Swap_Muscle_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Para que músculo?`)
};

const fr_fr2_swap_muscle_prompt = /** @type {(inputs: Swap_Muscle_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pour quel muscle ?`)
};

const de_de2_swap_muscle_prompt = /** @type {(inputs: Swap_Muscle_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Für welchen Muskel?`)
};

const it_it2_swap_muscle_prompt = /** @type {(inputs: Swap_Muscle_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Per quale muscolo?`)
};

/**
* | output |
* | --- |
* | "For which muscle?" |
*
* @param {Swap_Muscle_PromptInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const swap_muscle_prompt = /** @type {((inputs?: Swap_Muscle_PromptInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Swap_Muscle_PromptInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_swap_muscle_prompt(inputs)
	if (locale === "es-419") return es_419_swap_muscle_prompt(inputs)
	if (locale === "pt-PT") return pt_pt2_swap_muscle_prompt(inputs)
	if (locale === "fr-FR") return fr_fr2_swap_muscle_prompt(inputs)
	if (locale === "de-DE") return de_de2_swap_muscle_prompt(inputs)
	if (locale === "it-IT") return it_it2_swap_muscle_prompt(inputs)
	return en_us2_swap_muscle_prompt(inputs)
});
export { swap_muscle_prompt as "swap.muscle_prompt" }